import { render, staticRenderFns } from "./XuanKuaPaymentResult.vue?vue&type=template&id=1cf41c38&scoped=true"
import script from "./XuanKuaPaymentResult.vue?vue&type=script&lang=js"
export * from "./XuanKuaPaymentResult.vue?vue&type=script&lang=js"
import style0 from "./XuanKuaPaymentResult.vue?vue&type=style&index=0&id=1cf41c38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf41c38",
  null
  
)

export default component.exports